// Material
import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
// Localization
import { t } from '$i18n'

const StyledTypography = styled(Typography)`
  margin-right: 4px;
  display: contents;
`

export function WappRoomStatus() {
  const status = t('profile.wapp.tool')
  return (
    <StyledTypography variant="caption1" noWrap sx={{ color: 'gray' }}>
      {status}
    </StyledTypography>
  )
}
